module.exports = __webpack_public_path__ + "static/film-2-0ed10e338e2f6b0fe9ee56d63fb4e065.mp4";